import React from 'react';
import '../App.css'; 


const WorldTransit = () => {
  return (
    <div className="content-container">
      <p><i>This page is a work-in-progress. If you have any extra info for the page, <a href="https://commuter.fyi/contact" target="_blank" rel="noopener noreferrer">please let me know!</a></i></p>
      <h1>Public transport/transit information from around the world.</h1>
      <p>On this page, you can find weblinks to major public transportation systems from around the world. We hope this will help you in your travels!</p> 

      <p>FYI: This Wikipedia page has <a href="https://en.wikipedia.org/wiki/List_of_suburban_and_commuter_rail_systems" target="_blank" rel="noopener noreferrer">a list of suburban and commuter rail systems of major cities & countries.</a></p>


      <h2>Australia 🇦🇺</h2> 
      
      <p><a href="https://translink.com.au/" target="_blank" rel="noopener noreferrer">Queensland</a></p>
      <p><a href="https://www.ptv.vic.gov.au/" target="_blank" rel="noopener noreferrer">Victoria</a></p>
      <p><a href="https://transportnsw.info/" target="_blank" rel="noopener noreferrer">New South Wales</a></p>
      <p><a href="https://www.adelaidemetro.com.au/" target="_blank" rel="noopener noreferrer">South Australia</a></p>
      <p><a href="https://www.transperth.wa.gov.au/" target="_blank" rel="noopener noreferrer">Western Australia</a></p>
      <p><a href="https://www.metrotas.com.au/" target="_blank" rel="noopener noreferrer">Tasmania</a></p>
      <p><a href="https://www.transport.act.gov.au/" target="_blank" rel="noopener noreferrer">Australian Capital Territory (ACT)</a></p>
      <p><a href="https://nt.gov.au/" target="_blank" rel="noopener noreferrer">Northern Territory (NT)</a></p>

      <h2>Great Britain 🇬🇧</h2>
      <p><a href="https://www.visitbritain.com/en/plan-your-trip/travelling-around-britain" target="_blank" rel="noopener noreferrer">All transport info</a></p>

      <h2>France 🇫🇷</h2>
      <p><a href="https://www.ratp.fr/en" target="_blank" rel="noopener noreferrer">RATP - main website with all info</a></p>
      <p><a href="https://www.ratp.fr/en/horaires-metro" target="_blank" rel="noopener noreferrer">Metro timetable</a></p>
      <p><a href="https://www.ratp.fr/en/horaires-bus" target="_blank" rel="noopener noreferrer">Bus timetable</a></p>
      <p><a href="https://www.ratp.fr/en/horaires-tramway" target="_blank" rel="noopener noreferrer">Trams timetable</a></p>
      <p><a href="https://www.ratp.fr/en/horaires-rer" target="_blank" rel="noopener noreferrer">RER (Rapid Transit System) timetable</a></p>

      <h2>Indonesia 🇮🇩</h2>
      <p><a href="https://transjakarta.co.id/peta-rute/" target="_blank" rel="noopener noreferrer">TransJakarta</a></p>
      <p><a href="https://commuterline.id/perjalanan-krl/jadwal-kereta" target="_blank" rel="noopener noreferrer">KAI Commuter Rail (Jakarta, Tangerang, Depok, Bogor, and Bekasi.</a></p>
      <p><a href="https://jakartamrt.co.id/en" target="_blank" rel="noopener noreferrer">MRT Jakarta</a></p>

      <h2>Japan 🇯🇵</h2>
      <p><a href="https://www.jreast.co.jp/multi/en/" target="_blank" rel="noopener noreferrer">East Japan Railway Company</a></p>
      <p><a href="https://www.jrhokkaido.co.jp/global/index.html" target="_blank" rel="noopener noreferrer">Hokkaido Railway Company</a></p>
      <p><a href="https://www.jrkyushu.co.jp/english/" target="_blank" rel="noopener noreferrer">Kyushu Railway Company</a></p>
      <p><a href="https://www.jr-shikoku.co.jp/global/en/" target="_blank" rel="noopener noreferrer">Shikoku Railway Company</a></p>
      <p><a href="https://www.westjr.co.jp/global/en/" target="_blank" rel="noopener noreferrer">West Japan Railway Company</a></p>
      <p><a href="https://global.jr-central.co.jp/en/" target="_blank" rel="noopener noreferrer">Central Japan Railway Company</a></p>

      <h2>New Zealand 🇳🇿</h2>
      <p><a href="https://www.nzta.govt.nz/walking-cycling-and-public-transport/public-transport/travelling-by-public-transport/" target="_blank" rel="noopener noreferrer">New Zealand Transport Agency</a></p>
      <p><a href="https://www.intercity.co.nz/" target="_blank" rel="noopener noreferrer">Intercity</a></p>

      <h2>Singapore 🇸🇬</h2>
      <p><a href="https://www.lta.gov.sg/content/ltagov/en/getting_around/public_transport/rail_network.html" target="_blank" rel="noopener noreferrer">Rail Network</a></p>
      <p><a href="https://www.lta.gov.sg/content/ltagov/en/getting_around/public_transport/bus_network.html" target="_blank" rel="noopener noreferrer">Bus Network</a></p>
      <p><a href="https://www.simplygo.com.sg/card-collection-faq" target="_blank" rel="noopener noreferrer">SimplyGo travel card</a></p>

      <h2>USA 🇺🇸</h2>
      <p><a href="https://www.apta.com/research-technical-resources/public-transportation-links/" target="_blank" rel="noopener noreferrer">Link to transit agencies across USA</a></p>

    </div>
  );
};

export default WorldTransit;